import { 
  Appointment, 
  CoreAppointment, 
  CoreValidationFunctions, 
  CoreValidationType, 
  TransferValidationFunctions, 
  TransferValidationType 
} from "./interfaces"
import { isTransferAppointment } from "./typeGuards"
import { acceptRejectTransferValidation } from "./transferValidations"
import { acceptRejectCoreItemValidation } from "./coreValidations"

export const actionValidations = ({
  validation,
  a,
}: {
  validation: TransferValidationType | CoreValidationType
  a: Appointment | CoreAppointment
}): boolean => {
  if (isTransferAppointment(a)) {
    const validations: TransferValidationFunctions = {
      AcceptRejectTransferItemRequest: acceptRejectTransferValidation
    }
    return validations[validation as TransferValidationType](a);
  } else {
    const coreValidations: CoreValidationFunctions = {
      AcceptRejectCoreItemRequest: acceptRejectCoreItemValidation
    }
    return coreValidations[validation as CoreValidationType](a);
  }
}
